import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
export const CollectionItemLongDescription = (param)=>{
    let { longDescription } = param;
    const [expanded, setExpanded] = React.useState(false);
    const textRef = React.useRef(null);
    const [isClamped, setIsClamped] = React.useState(false);
    React.useEffect(()=>{
        const el = textRef.current;
        if (el) setIsClamped(el.scrollHeight > el.clientHeight);
    }, [
        longDescription
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "ci__description-long",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "ci__section-title",
                children: "Beschrijving"
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: textRef,
                className: `description__text${expanded ? "" : " description__text--clamped"}`,
                children: longDescription
            }),
            (isClamped || expanded) && /*#__PURE__*/ _jsxs("button", {
                className: "link ci__description-toggle",
                onClick: ()=>setExpanded((s)=>!s),
                "aria-expanded": expanded,
                children: [
                    "Lees ",
                    expanded ? "minder" : "meer"
                ]
            })
        ]
    });
};
